import {
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  gap,
  letterSpacings,
  lineHeights,
} from '../utils/view';

export const theme = {
  colors,

  space: gap,

  fonts: fonts,

  fontSizes: fontSizes,

  fontWeights: fontWeights,

  lineHeights: lineHeights,

  letterSpacings: letterSpacings,

  breakpoints: breakpoints,
};


